//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminBillingDocumentController_updateOneById,
  Response$AdminBillingDocumentController_updateOneById$Status$200,
  ResponseContentType$AdminBillingDocumentController_updateOneById,
} from '@api-client/generated/client';
import { useApiClientMutation } from '@hooks/useApiClientMutation';

export const useAdminBillingDocumentController_updateOneById = () =>
  useApiClientMutation<
    Params$AdminBillingDocumentController_updateOneById,
    Response$AdminBillingDocumentController_updateOneById$Status$200[ResponseContentType$AdminBillingDocumentController_updateOneById]
  >({ method: 'AdminBillingDocumentController_updateOneById' });
